import React from "react";
import { Layout } from "../../layouts/Layout";
import { useTranslation } from "react-i18next";
import { AboutTen } from "../../components/About/AboutTen";
import { FeatureSix } from "../../components/Features/FeatureSix";
import { FeatureSeven } from "../../components/Features/FeatureSeven";
import { BrandSix } from "../../components/Brand/BrandSix";
import { CtaAreaTwo } from "../../components/CtaAreas/CtaAreaTwo";
import { BlogAreaThree } from "../../components/BlogAreas/BlogAreaThree";

const AboutPageFour = () => {
  const { t } = useTranslation();
  return (
    <Layout footer={2} breadcrumb={t("pages.about.breadcrumb")} title={t("pages.about.title")}>
      {/* about-area */}
      <AboutTen />

      {/* features-area */}
      <FeatureSix />

      {/* features-area */}
      <FeatureSeven />

      {/* cta-area */}
      <CtaAreaTwo />

      {/* blog-area */}
      <BlogAreaThree />

      {/* brand-area */}
      <BrandSix />
    </Layout>
  );
};

export default AboutPageFour;
